//
// CompactLabelFormatOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GTLModel";
import "./CompactLabelFormatScale";
import "./CompactLabelFormatPrecision";

var CompactLabelFormatOptions = createModule("gtl::CompactLabelFormatOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        scaleType: 4,
        precision: 3,
        scale: 3,
        precisionType: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CompactLabelFormatOptions;
